import { render, staticRenderFns } from "./claim-view.vue?vue&type=template&id=2fabcbe4&"
import script from "./claim-view.vue?vue&type=script&lang=ts&"
export * from "./claim-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports